import { render, staticRenderFns } from "./ChangePrescriptionImg.vue?vue&type=template&id=5be3239c&scoped=true&"
import script from "./ChangePrescriptionImg.vue?vue&type=script&lang=js&"
export * from "./ChangePrescriptionImg.vue?vue&type=script&lang=js&"
import style0 from "./ChangePrescriptionImg.vue?vue&type=style&index=0&id=5be3239c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be3239c",
  null
  
)

export default component.exports